import { styled } from 'styled-components';

import { Box } from '#/components/Box/Box';
import { Button } from '#/components/Button/Button';
import { H2 } from '#/components/Text/H2';
import { Text } from '#/components/Text/Text';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { ApiOrg } from '#/modules/listing/orgs/api/types/ApiOrg';
import { getCityStateString } from '#/utils/address/getCityStateString';
import { trackClicked } from '#/utils/analytics/track/trackClicked';
import { getStaticImageSrc } from '#/utils/getImageSrc';
import { idealistDateString } from '#/utils/string/datetime/convertDatetimeString';
import { humanMonthYear } from '#/utils/string/datetime/dateString';

const SupportButton = styled(Button)`
  margin-top: 16px;
`;

const RocketIcon = styled.img`
  width: 17px;
  height: 17px;
`;

const SupportButtonContent = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
`;

type Props = {
  org: ApiOrg;
};

export function ViewOrgPageSidebarTitle({ org }: Props) {
  const { i18n, locale } = useI18n();

  return (
    <Box display="flex" flexDirection="column">
      <H2 styleAs="h3" m="0">
        {org.name}
      </H2>
      <Box my="4px">
        {org.address && <>{getCityStateString(i18n, org.address)}</>}
      </Box>
      <Text
        display={['inline-block', 'inline-block', 'inline-block', 'block']}
        color="lightContentGrey"
      >
        {i18n('Joined in %(monthAndYear)s', {
          monthAndYear: humanMonthYear(idealistDateString(org.created), {
            locale,
            monthFormat: 'long',
          }),
        })}
      </Text>
      {org.donationLink && (
        <Box mt="8px">
          <SupportButton
            type="link"
            href={org.donationLink}
            variant="glow-up"
            onClick={() => {
              trackClicked('Support Organization on Profile');
            }}
          >
            <SupportButtonContent>
              <RocketIcon src={getStaticImageSrc('rocket-gradient.svg')} />
              {i18n('Support Our Work')}
            </SupportButtonContent>
          </SupportButton>
        </Box>
      )}
    </Box>
  );
}
